module.exports = __webpack_public_path__ + "img/20f9.545074fc.jpg";